'use client';

import React from 'react';

import { Field, FormikProps } from 'formik';
import { useTranslations } from 'next-intl';

import { THUMB_STATE } from '../constants';
import { useFeedbackFormContext } from '../Form/FeedbackFormContext';
import { OrangeText } from '../Form/Form.styled';
import { RadioButtons, Textarea, ErrorMessage, ControlButtons } from '../Form/Form.styled';
import RadioButton from '../Form/RadioButton';
import RecaptchaSubmitButton from '../Form/RecaptchaSubmitButton';
import IntlText from '../IntlText';
import messages from '../messages';
import Button from '@/ui/components/Button';

const cannedResponse = {
  [THUMB_STATE.UP]: [
    messages.cannedResponse.positiveOne,
    messages.cannedResponse.positiveTwo,
    messages.cannedResponse.positiveThree,
  ],
  [THUMB_STATE.DOWN]: [
    messages.cannedResponse.negativeOne,
    messages.cannedResponse.negativeTwo,
    messages.cannedResponse.negativeThree,
    messages.cannedResponse.negativeFour,
  ],
};

interface FormValues {
  feedback_canned_response: string;
  feedback_message: string;
}

interface FormErrors {
  feedback_error?: string;
  feedback_canned_response?: string;
  feedback_message?: string;
}

interface FormProps extends Omit<FormikProps<FormValues>, 'errors'> {
  errors: FormErrors;
}

/**
 * @todo cancel button CancelButton
 */
const Form: React.FC<FormProps> = ({ errors, touched, submitForm, isSubmitting, setFieldTouched, setErrors }) => {
  const { thumbState, closeAction } = useFeedbackFormContext();
  const translate = useTranslations();

  return (
    <>
      <OrangeText>
        {thumbState && <IntlText index={thumbState === THUMB_STATE.UP ? messages.great : messages.why} />}
      </OrangeText>

      <RadioButtons>
        {cannedResponse[thumbState || THUMB_STATE.UP].map((responseMessage, index) => {
          return (
            <Field
              key={index}
              component={RadioButton}
              name="feedback_canned_response"
              id={translate(responseMessage)}
              onClickAction={setFieldTouched}
              label={translate(responseMessage)}
            />
          );
        })}
      </RadioButtons>

      <Field name="feedback_message">
        {({ field }) => {
          return (
            <Textarea
              name={field.name}
              value={field.value}
              onChange={field.onChange}
              placeholder={translate(messages.textbox)}
            />
          );
        }}
      </Field>

      {errors?.feedback_error && <ErrorMessage>{errors.feedback_error}</ErrorMessage>}

      <ControlButtons>
        <RecaptchaSubmitButton
          onSubmitAction={submitForm}
          disabled={isSubmitting || !Object.keys(touched).length || Object.keys(errors).length}
          setErrors={setErrors}
        >
          <IntlText index={messages.submit} />
        </RecaptchaSubmitButton>

        <Button onClick={closeAction}>
          <IntlText index={messages.cancel} />
        </Button>
      </ControlButtons>
    </>
  );
};

export default Form;
